import { render, staticRenderFns } from "./Duel_Statistics.vue?vue&type=template&id=2e42cf7f&scoped=true&"
import script from "./Duel_Statistics.vue?vue&type=script&lang=js&"
export * from "./Duel_Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42cf7f",
  null
  
)

export default component.exports